<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.normNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.normName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="normNumber" label="编码" width="120" />
      <el-table-column prop="normName" label="名称" min-width="120" show-overflow-tooltip />
      <el-table-column label="产线" width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.productionLineName || '全部产线' }}</template>
      </el-table-column>
      <el-table-column label="换前产品" min-width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ productLabel(row.fromProductNumber, row.fromProductName) }}</template>
      </el-table-column>
      <el-table-column label="换后产品" min-width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ productLabel(row.toProductNumber, row.toProductName) }}</template>
      </el-table-column>
      <el-table-column prop="durationMin" label="换型分钟" width="100" align="right" />
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">是</el-tag>
          <el-tag v-else size="mini" type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.normId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.normId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.normId ? '修改换型定额' : '新增换型定额'" :visible.sync="visible" width="640px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="编码" prop="normNumber">
          <el-input v-model="form.normNumber" />
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="form.normName" />
        </el-form-item>
        <el-form-item label="产线">
          <el-select v-model="form.productionLineId" filterable clearable style="width:100%" placeholder="空=全部产线">
            <el-option v-for="l in lineOptions" :key="l.lineId" :label="l.lineName" :value="l.lineId" />
          </el-select>
        </el-form-item>
        <el-form-item label="换前产品" prop="fromProductId">
          <el-input :value="fromLabel" readonly placeholder="点击选择">
            <el-button slot="append" icon="el-icon-search" @click="openProductPicker('from')" />
          </el-input>
        </el-form-item>
        <el-form-item label="换后产品" prop="toProductId">
          <el-input :value="toLabel" readonly placeholder="点击选择">
            <el-button slot="append" icon="el-icon-search" @click="openProductPicker('to')" />
          </el-input>
        </el-form-item>
        <el-form-item label="换型分钟" prop="durationMin">
          <el-input-number v-model="form.durationMin" :min="0" :precision="2" style="width:100%" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择产品" :visible.sync="productPickerVisible" width="720px" append-to-body :close-on-click-modal="false">
      <div class="toolbar" style="margin-bottom:12px">
        <el-input v-model="productPickerQuery" clearable placeholder="产品编码/名称" style="width:220px" @keyup.enter.native="loadProductPicker" />
        <el-button type="primary" icon="el-icon-search" @click="loadProductPicker">查询</el-button>
      </div>
      <el-table :data="productPickerList" border v-loading="productPickerLoading" height="360" @row-dblclick="onProductPicked">
        <el-table-column prop="productNumber" label="编码" width="140" />
        <el-table-column prop="productName" label="名称" min-width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onProductPicked(row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="productPickerVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listLineChangeoverNorm, getLineChangeoverNorm, saveLineChangeoverNorm,
  updateLineChangeoverNorm, deleteLineChangeoverNorm
} from '../../api/lineChangeoverNorm'
import { selectProductionLine } from '../../api/productionLine'
import { listProduct } from '../../api/product'

function emptyForm() {
  return {
    normId: '',
    normNumber: '',
    normName: '',
    productionLineId: '',
    fromProductId: '',
    toProductId: '',
    durationMin: 30,
    active: '1',
    remark: ''
  }
}

export default {
  name: 'MesLineChangeoverNormPage',
  components: { ListPagination },
  data() {
    return {
      query: { normNumber: '', normName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      form: emptyForm(),
      rules: {
        normNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        fromProductId: [{ required: true, message: '请选择换前产品', trigger: 'change' }],
        toProductId: [{ required: true, message: '请选择换后产品', trigger: 'change' }],
        durationMin: [{ required: true, message: '请填写换型分钟', trigger: 'change' }]
      },
      lineOptions: [],
      fromLabel: '',
      toLabel: '',
      productPickerVisible: false,
      productPickerLoading: false,
      productPickerList: [],
      productPickerQuery: '',
      pickSide: 'from'
    }
  },
  created() {
    this.load()
    this.loadLines()
  },
  methods: {
    productLabel(number, name) {
      const a = number || ''
      const b = name || ''
      if (!a && !b) return '-'
      return a + (b ? ' / ' + b : '')
    },
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    loadLines() {
      selectProductionLine().then(res => {
        this.lineOptions = res.data || []
      }).catch(() => {})
    },
    load() {
      this.loading = true
      listLineChangeoverNorm({
        currentPage: this.page,
        pageSize: this.pageSize,
        normNumber: this.query.normNumber,
        normName: this.query.normName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.fromLabel = ''
      this.toLabel = ''
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getLineChangeoverNorm(id).then(res => {
        const row = res.data || {}
        this.form = Object.assign(emptyForm(), row)
        this.fromLabel = this.productLabel(row.fromProductNumber, row.fromProductName)
        this.toLabel = this.productLabel(row.toProductNumber, row.toProductName)
      })
    },
    openProductPicker(side) {
      this.pickSide = side
      this.productPickerQuery = ''
      this.productPickerVisible = true
      this.loadProductPicker()
    },
    loadProductPicker() {
      this.productPickerLoading = true
      listProduct({
        currentPage: 1,
        pageSize: 50,
        productNumber: this.productPickerQuery,
        active: '1'
      }).then(res => {
        const body = res.data || {}
        this.productPickerList = body.list || []
      }).finally(() => { this.productPickerLoading = false })
    },
    onProductPicked(row) {
      if (!row) return
      const label = this.productLabel(row.productNumber, row.productName)
      if (this.pickSide === 'from') {
        this.form.fromProductId = row.productId
        this.fromLabel = label
      } else {
        this.form.toProductId = row.productId
        this.toLabel = label
      }
      this.productPickerVisible = false
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (this.form.fromProductId === this.form.toProductId) {
          this.$message.warning('换前与换后产品不能相同')
          return
        }
        this.saving = true
        const req = this.form.normId ? updateLineChangeoverNorm(this.form) : saveLineChangeoverNorm(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.normId)
      if (!ids.length) return
      this.$confirm('确定删除所选换型定额？', '提示', { type: 'warning' }).then(() => {
        deleteLineChangeoverNorm(ids).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
